import React from 'react';
import { PageHero } from '../components/PageUI';

const ObrigadoDownloadPage = () => (
  <div>
    <PageHero
      eyebrow="Obrigado"
      title="Download liberado."
      subtitle="Confira seu e-mail para acessar o material."
      primaryCta={{ label: 'Agendar demo', href: '/demonstracao' }}
      secondaryCta={{ label: 'Voltar para materiais', href: '/materiais' }}
    />
  </div>
);

export default ObrigadoDownloadPage;
